import React from "react";
import { useMeAI } from "@/context/MeAIContext";
import { useLanguage } from "@/context/LanguageContext";

/**
 * Tiny presence pill that lives in the AppShell topbar.
 * Shows the active device (if any) and links to /devices.
 */
export function MeAIPresence() {
  const { being } = useMeAI();
  const { t } = useLanguage();

  const isOnline = being?.presence === "online";
  const device = being?.current_device;

  return (
    <a
      href="/devices"
      className="group inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900"
      data-testid="meai-presence"
      title={t.meai.title}
    >
      <span
        className={`relative inline-block h-2 w-2 rounded-full ${isOnline ? "bg-emerald-500" : "bg-slate-300"}`}
      >
        {isOnline && (
          <span className="absolute inset-0 -m-0.5 animate-ping rounded-full bg-emerald-400/40" />
        )}
      </span>
      <span className="font-medium text-slate-900">ME AI</span>
      {device && <span className="hidden md:inline">· {device.name}</span>}
      {!device && <span className="hidden md:inline text-slate-400">· {t.meai.offline}</span>}
    </a>
  );
}
